(function () {

  const safeStore = {
    getItem(key) {try{return sessionStorage.getItem(key);}catch{return null;}},
    setItem(key,value) {try{sessionStorage.setItem(key,value);}catch{}},
    removeItem(key) {try{sessionStorage.removeItem(key);}catch{}}
  };
  let projectLink = null, routeLink = null;
  document.addEventListener('click',event=>{
    projectLink = !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button===0
      ? event.target.closest?.('[data-dkt-project-link]') : null;
    routeLink = !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button===0
      ? event.target.closest?.('[data-dkt-route-link]') : null;
  },{capture:true});
  function clearProjectNames(){
    document.querySelectorAll('[data-dkt-project-image]').forEach(el=>el.style.removeProperty('view-transition-name'));
  }
  window.addEventListener('pageshow',()=>{projectLink=null;routeLink=null;});
  function observeTransition(transition,kind){
    document.documentElement.dataset.dktTransition=kind;
    transition.ready.then(()=>{document.documentElement.dataset.dktTransitionResult='captured';}).catch(()=>{});
    transition.finished.then(()=>{document.documentElement.dataset.dktTransitionResult='finished';}).catch(()=>{document.documentElement.dataset.dktTransitionResult='skipped';});
  }
  function selectProjectImage(key,preferred){
    if(!['tavi','b2b','presence','game'].includes(key))return null;
    const candidates=[...document.querySelectorAll('[data-dkt-project-image="'+key+'"]')];
    return preferred?.closest('[data-dkt-project-surface]')?.querySelector('[data-dkt-project-image]')
      || candidates.find(el=>{const r=el.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;}) || candidates[0];
  }
  function prepareProjectSwap(event){
    clearProjectNames();
    safeStore.removeItem('dkt-project-transition');
    const destination=event.activation?.entry?.url;
    if(!destination)return false;
    const target=new URL(destination);
    if(target.origin!==location.origin)return false;
    const destinationKey=target.searchParams.get('view')?.replace('dkt-','');
    const targetPath=target.pathname.replace(/\/$/,'');
    const returnsToGallery=targetPath===''||targetPath==='/en'||targetPath==='/pages/portfolio'||targetPath==='/en/pages/portfolio';
    const currentKey=document.querySelector('[data-dkt-project-page]')?.dataset.dktProjectPage;
    const key=destinationKey||(returnsToGallery?currentKey:null);
    if(!key)return false;
    const candidate=selectProjectImage(key,projectLink);
    if(!candidate)return false;
    candidate.style.viewTransitionName='dkt-project';
    event.viewTransition.types.clear();event.viewTransition.types.add('dkt-project');
    observeTransition(event.viewTransition,'project');
    safeStore.setItem('dkt-project-transition',JSON.stringify({key,destination:target.href}));
    event.viewTransition.finished.catch(()=>{}).finally(clearProjectNames);
    return true;
  }
  async function revealProject(event){
    let state;try{state=JSON.parse(safeStore.getItem('dkt-project-transition'));}catch{}
    safeStore.removeItem('dkt-project-transition');
    if(!state||state.destination!==location.href)return false;
    const candidate=selectProjectImage(state.key);
    if(!candidate)return false;
    candidate.style.viewTransitionName='dkt-project';
    event.viewTransition.types.clear();event.viewTransition.types.add('dkt-project');
    observeTransition(event.viewTransition,'project');
    event.viewTransition.finished.catch(()=>{}).finally(clearProjectNames);
    return true;
  }

  function clearRouteNames(){
    document.querySelectorAll('[data-dkt-route-image]').forEach(el=>el.style.removeProperty('view-transition-name'));
  }
  function prepareRouteSwap(event){
    safeStore.removeItem('dkt-route-transition');
    const destination=event.activation?.entry?.url;
    if(!routeLink||routeLink.href!==destination)return false;
    const key=routeLink.dataset.dktRouteLink;
    if(!['offers','method','portfolio_intro','contact'].includes(key))return false;
    const candidate=routeLink.querySelector('[data-dkt-route-image]');
    if(!candidate)return false;
    candidate.style.viewTransitionName='dkt-route';
    event.viewTransition.types.clear();event.viewTransition.types.add('dkt-route');
    safeStore.setItem('dkt-route-transition',JSON.stringify({key,destination}));
    observeTransition(event.viewTransition,'route');
    event.viewTransition.finished.catch(()=>{}).finally(clearRouteNames);
    return true;
  }
  function revealRoute(event){
    let state;try{state=JSON.parse(safeStore.getItem('dkt-route-transition'));}catch{}
    safeStore.removeItem('dkt-route-transition');
    if(!state||state.destination!==location.href||!['offers','method','portfolio_intro','contact'].includes(state.key))return false;
    const candidate=document.querySelector('dkt-page-scene[data-dkt-route-image="'+state.key+'"]');
    if(!candidate)return false;
    candidate.style.viewTransitionName='dkt-route';
    event.viewTransition.types.clear();event.viewTransition.types.add('dkt-route');
    observeTransition(event.viewTransition,'route');
    event.viewTransition.finished.catch(()=>{}).finally(clearRouteNames);
    return true;
  }

  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
  // Remove the view transition render blocker if the user has reduced motion enabled or is on a low power device.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice()) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // If the browser didn't manage to parse the main content quickly, at least let the user see something.
    // We're aiming for the FCP to be under 1.8 seconds since the navigation started.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    if (prepareProjectSwap(event)) return;
    if (prepareRouteSwap(event)) return;

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      safeStore.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      safeStore.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      /** @type {ViewTransition | null} */ (viewTransition)?.skipTransition();
      return;
    }

    if (await revealProject(event)) return;
    if (revealRoute(event)) return;

    observeTransition(viewTransition,'page');
    const customTransitionType = safeStore.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        safeStore.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * @param {ViewTransition | null} viewTransition
   * @returns {viewTransition is null}
   */
  function shouldSkipViewTransition(viewTransition) {
    return !viewTransition || window.matchMedia('(prefers-reduced-motion: reduce)').matches || isLowPowerDevice();
  }

  /*
   * We can't import this logic from utilities.js here, but we should keep them in sync.
   */
  function isLowPowerDevice() {
    /* Skip ESLint compatibility check. Number(undefined) <= 2 is always false anyway. */
    /* eslint-disable-next-line compat/compat */
    return Number(navigator.hardwareConcurrency) <= 2 || Number(navigator.deviceMemory) <= 2;
  }
})();
